/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Platform_LabelInputs */

const tr_mesafeli_s3_platform_label = /** @type {(inputs: Mesafeli_S3_Platform_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform / ShopPanel:`)
};

const en_mesafeli_s3_platform_label = /** @type {(inputs: Mesafeli_S3_Platform_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform / ShopPanel:`)
};

const de_mesafeli_s3_platform_label = /** @type {(inputs: Mesafeli_S3_Platform_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform / ShopPanel:`)
};

const ru_mesafeli_s3_platform_label = /** @type {(inputs: Mesafeli_S3_Platform_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа / ShopPanel:`)
};

/**
* | output |
* | --- |
* | "Platform / ShopPanel:" |
*
* @param {Mesafeli_S3_Platform_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_platform_label = /** @type {((inputs?: Mesafeli_S3_Platform_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Platform_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_platform_label(inputs)
	if (locale === "de") return de_mesafeli_s3_platform_label(inputs)
	if (locale === "ru") return ru_mesafeli_s3_platform_label(inputs)
	return tr_mesafeli_s3_platform_label(inputs)
});